module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('date-range-picker', {
    on: {
      "daterange-change": _vm.dateRangeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', [_vm._v(_vm._s(_vm.dateRangeFormat(_vm.dateStart)) + " - " + _vm._s(_vm.dateRangeFormat(_vm.dateEnd)))])])]), _vm._v(" "), _c('bootstrap-panel', {
    attrs: {
      "title": "Appliance Locations"
    }
  }, [_c('google-map', {
    attrs: {
      "coordinates": _vm.trackCoordinates,
      "height": "400px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.appliancesChartOptions,
      "series": _vm.appliancesChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.versionsChartOptions,
      "series": _vm.versionsChartSeries
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.requestsChartOptions,
      "series": _vm.requestsChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.malwareChartOptions,
      "series": _vm.malwareChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.bytesChartOptions,
      "series": _vm.bytesChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.connectionsChartOptions,
      "series": _vm.connectionsChartSeries
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.aiMalwareChartOptions,
      "series": _vm.aiMalwareChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.aiGraywareChartOptions,
      "series": _vm.aiGraywareChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.sandboxMalwareChartOptions,
      "series": _vm.sandboxMalwareChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.sandboxCleanChartOptions,
      "series": _vm.sandboxCleanChartSeries
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.urlsChartOptions,
      "series": _vm.urlsChartSeries
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('high-chart', {
    attrs: {
      "options": _vm.spamChartOptions,
      "series": _vm.spamChartSeries
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-27f743ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Home.vue
// module id = 491
// module chunks = 2